import { baseResponseSchema } from 'api/api.config';
import { z } from 'zod';

export const signupPDVResponse = baseResponseSchema.extend({
  email: z.string(),
  birthDate: z.string(),
  name: z.string(),
  surname: z.string(),
  accountCode: z.string(),
});

export type SignupPDVResponseIType = z.infer<typeof signupPDVResponse>;
